import { useCallback } from "react";
import { SymbolV2 } from "@bn/api/apiv1";
import { useInstrumentUrl } from "./useInstrumentUrl";
import { useMandatorFeature } from "./useMandatorFeature";

export const buildSecurityPagePath = (id: string, quoteProvider: string) =>
  `/securities?id=${encodeURIComponent(id)}&quoteProvider=${encodeURIComponent(
    quoteProvider
  )}`;

/**
 * Where a symbol picked out of the search should link to.
 *
 * Mirrors {@link useInvestmentLink}: mandators with the in-app security page
 * link there, everyone else keeps falling back to the mandator's external
 * instrument page, which only resolves for some instruments.
 */
export const useSecurityLink = () => {
  const getInstrumentUrl = useInstrumentUrl();
  const hasSecurityDetailPage = useMandatorFeature("securityDetailPage");

  return useCallback(
    (symbol: SymbolV2): string | undefined => {
      if (hasSecurityDetailPage && symbol.id) {
        return buildSecurityPagePath(symbol.id, symbol.quoteProvider);
      }

      return getInstrumentUrl(symbol);
    },
    [hasSecurityDetailPage, getInstrumentUrl]
  );
};
